import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { NavMainItem } from "../Interface/NavBar";
import { openWindowsForItem } from "../utils/openNewWindowTab";
import { SubmenuLink } from "./nav-buttons";
import { NavItemIcon } from "./nav-icon";

// Component for rendering simple navigation items without sub-menus
export function SimpleNavItem({ item }: { item: NavMainItem }) {
	if (item.openInNewWindow) {
		return <NavItemWithNewWindow item={item} />;
	} else if (item.openInNewTab) {
		return <NavBarItemWithNewTab item={item} />;
	} else {
		return <NavBarItem item={item} />;
	}
}

// Component for navigation items that open new windows
export function NavItemWithNewWindow({ item }: { item: NavMainItem }) {
	const handleClick = () => {
		openWindowsForItem(item);
	};

	return (
		<SidebarMenuItem>
			<SidebarMenuButton onClick={handleClick} tooltip={item.title}>
				<NavItemIcon icon={item.icon} />
				<span>{item.title}</span>
			</SidebarMenuButton>
		</SidebarMenuItem>
	);
}

export function NavBarItem({ item }: { item: NavMainItem }) {
	return (
		<SidebarMenuItem>
			<SidebarMenuButton asChild tooltip={item.title}>
				<SubmenuLink item={item} />
			</SidebarMenuButton>
		</SidebarMenuItem>
	);
}

// Component for navigation items that open new tabs
export function NavBarItemWithNewTab({ item }: { item: NavMainItem }) {
	return (
		<SidebarMenuItem>
			<SidebarMenuButton
				onClick={() => window.open(item.url, "_blank")}
				tooltip={item.title}
			>
				<NavItemIcon icon={item.icon} />
				<span>{item.title}</span>
			</SidebarMenuButton>
		</SidebarMenuItem>
	);
}
